var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AsciiText } from './framework/AsciiText';
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class WolfVisionCynap {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.log = log;
        this.framework = framework;
        // other class properties and constructor
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        this.cynapCall = 'webCall';
        this.cynapVideoOutput = '1';
        this.debug = false;
        this.supportedCallTypes = {};
        this.zoomSourceCode = '15';
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send('\x08\xCB\x50\x00', /\x0C\xCB\x50[\s\S]+"version":"V(.+)","buildnumber":"(\d+)"/i, tags);
                return `${match[1]} (build ${match[2]})`;
            }),
        };
        this.mute = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\x08\xcb\x59\x00`, /\x08\xcb\x59\x01([\s\S])|\x88\xcb\x59[\s\S]/i, tags);
                if (match[1])
                    return match[1] === '\x01';
                return this.state.mute.value;
            }),
            set: (mute, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(AsciiText.decode([0x09, 0xcb, 0x59, 0x01, mute ? 1 : 0]), /([\x09\x89\x99])\xcb\x59[\s\S]/i, tags);
                if (match[1] === '\x09')
                    return mute;
                return this.state.mute.value;
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\x08\xCB\x0C\x00`, /\x08\xCB\x0C\x01([\x00\x01])/, tags);
                return match[1] === '\x01';
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), power ? 3000 : 1000);
                const match = yield this.socket.send(AsciiText.decode([0x09, 0xcb, 0x0c, 0x01, power ? 0x01 : 0x00]), /(\x09\xCB\x0C\x00)|\x89\xCB\x0c[\s\S]+/, tags);
                return match[1] ? power : this.state.power.value;
            }),
        };
        this.telephony = {
            answer: (key) => __awaiter(this, void 0, void 0, function* () {
                return true;
            }),
            call: (value) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c, _d, _e;
                let dialUrl;
                let displayDialString;
                let callId;
                if (value.callType === 'zoom') {
                    // Don't use the Zoom 6 digit passcode as part of the dial url since Zoom webRTC can
                    // only use the long hashed passcode.
                    let passcode = (_d = (_b = (_a = value.alternateMeetingCodes) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : (_c = value.meetingCodes) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : '';
                    passcode = passcode.length > 6 ? '?pwd=' + passcode : '';
                    dialUrl = `https://us02web.zoom.us/j/${value.dialString}${passcode}`;
                    displayDialString = this.formatZoomMeetingId(value.dialString);
                }
                else {
                    dialUrl = value.dialString;
                    displayDialString = 'Microsoft Teams Meeting';
                }
                if (this.state.videoMatrixRoutes.values[this.cynapVideoOutput] === '15' ||
                    this.state.videoMatrixRoutes.values[this.cynapVideoOutput] === '27' ||
                    this.state.videoMatrixRoutes.values[this.cynapVideoOutput] === '29') {
                    // If already on the teams input then insert a short delay after ending the current
                    // presentation/source, otherwise Wolfvision can add a 2 minute delay trying to
                    // connect a call. Note: this causes the driver to hang for the duration of the
                    // delay.
                    this.state.calls.call(this.cynapCall, value.callType, undefined, {
                        dialString: value.dialString,
                        displayDialString,
                    });
                    callId = (_e = this.state.calls.values[this.cynapCall]) === null || _e === void 0 ? void 0 : _e.callId;
                    this.state.busy.update(true);
                    yield this.endPresentation(['call.telephony']);
                    yield this.timeouts.delay(2000);
                    this.state.busy.update(false);
                }
                const dialCommand = AsciiText.decode([
                    0x0b,
                    0x01,
                    0xcd,
                    0x28,
                    0,
                    0,
                    ...this.byteLen(dialUrl.length + 7),
                    0,
                    value.callType === 'zoom' ? parseInt(this.zoomSourceCode, 10) : 0x1b,
                    ...this.byteLen(dialUrl.length),
                    ...this.encode(dialUrl),
                    0,
                    0,
                    0, // private data length = 0
                ]);
                const match = yield this.socket.send(dialCommand, /([\x09\x89])\xcd\x28[\s\S]/, [`call.telephony`], { sendTimeoutMs: 6000 });
                if (match[1] === '\x09') {
                    this.state.calls.call(this.cynapCall, value.callType, callId, {
                        dialString: value.dialString,
                        displayDialString,
                    });
                }
                else {
                    this.state.calls.disconnect(this.cynapCall);
                }
                return undefined;
            }),
            dial: (key, value) => __awaiter(this, void 0, void 0, function* () {
                return value;
            }),
            getCalls: () => __awaiter(this, void 0, void 0, function* () {
                // calls state initialized in onConfigure; shallow copy required since the framework
                // deletes all entries from this.state.calls
                return Object.assign({}, this.state.calls.values);
            }),
            getMaxCalls: () => __awaiter(this, void 0, void 0, function* () {
                return this.supportedCallTypes;
            }),
            hangup: (key) => __awaiter(this, void 0, void 0, function* () {
                const result = yield this.endPresentation(['hangup.telephony']);
                return result;
            }),
            reject: (key) => __awaiter(this, void 0, void 0, function* () {
                const result = yield this.endPresentation(['reject.telephony']);
                return result;
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                if (key !== this.cynapVideoOutput)
                    this.log.error(`invalid video output`);
                return this.state.videoMatrixRoutes.values[key]; // initialized in onConfigure
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                if (key !== this.cynapVideoOutput)
                    this.log.error(`invalid video output`);
                const match = yield this.endPresentation(tags);
                if (value === '0') {
                    // set to default cynap home screen
                    if (match)
                        return value;
                    return this.state.videoMatrixRoutes.values[key];
                }
                else {
                    // change the video input
                    this.state.busy.update(true);
                    this.busyTimeout.set(() => this.state.busy.update(false), value === '15' || value === '27' || value === '29' ? 10000 : 3000);
                    const command = [
                        0,
                        // translate input HDMI 2 to use HDMI 1 source and index = 1
                        parseInt(value === '80' ? '2' : value, 10),
                    ];
                    if (value === '80' || value === '2') {
                        command.push(0, 1); // add length of the index field: lp0, lp1
                        command.push(value === '80' ? 1 : 0); // if HDMI 2 selected, set index
                    }
                    else if (value === '15' || value === '29') {
                        // Set the default URL for webConference and Zoom inputs. If we don't specify a
                        // default URL for the Zoom (0x1D) source, the Wolfvision Cynap doesn't like it
                        // and we can never end the presentation.
                        const url = 'https://zoom.us/';
                        command.push(...this.byteLen(url.length)); //set length: lp0, lp1
                        command.push(...this.encode(url)); // set p0.. pn
                    }
                    else {
                        // no additional parameters required for other sources
                        command.push(0, 0); //set length: lp0,lp1
                    }
                    command.push(0, 0, 0); // add restricted and private fields
                    // windows start private command
                    const srcMatch = yield this.socket.send(AsciiText.decode([
                        0x0b,
                        0x01,
                        0xcd,
                        0x28,
                        ...this.byteLen(command.length, 4),
                        ...command,
                    ]), /([\x09\x89\x99])\xCD\x28[\s\S]+/, tags);
                    if (srcMatch[1] === '\x09')
                        return value;
                }
                return this.state.videoMatrixRoutes.values[key];
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        this.volume = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\x08\xcb\x56\x00`, /([\x08\x88])\xcb\x56\x01([\s\S])/i, tags);
                if (match[1] === '\x08')
                    return match[2].charCodeAt(0);
                return this.state.volume.value;
            }),
            set: (volume, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(AsciiText.decode([0x09, 0xcb, 0x56, 0x01, volume]), /([\x09\x89\x99])\xcb\x56[\s\S]/i, tags);
                if (match[1] === '\x09')
                    return volume;
                return this.state.volume.value;
            }),
            powerOffRestrictions: ['get', 'set'],
            range: { max: 100, min: 0, round: 1 },
        };
        this.volumeMute = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\x08\xcb\x58\x00`, /\x08\xcb\x58\x01([\s\S])|\x88\xcb\x58[\s\S]/i, tags);
                if (match[1])
                    return match[1] === '\x01';
                return this.state.volumeMute.value;
            }),
            set: (mute, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(AsciiText.decode([0x09, 0xcb, 0x58, 0x01, mute ? 1 : 0]), /([\x09\x89\x99])\xcb\x58[\s\S]/i, tags);
                if (match[1] === '\x09')
                    return mute;
                return this.state.volumeMute.value;
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        // polling
        this.polls = [
            {
                intervalMs: 3000,
                function: () => __awaiter(this, void 0, void 0, function* () {
                    return this.updateCallsAndVideoMatrixRoutes([
                        'poll',
                        'get.telephony',
                        'get.videoMatrixRoutes',
                    ]);
                }),
            },
            {
                intervalMs: 3000,
                onePerInterval: true,
                controls: ['power', 'mute', 'volumeMute', 'volume'],
            },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
            const videoInputs = (_a = config.videoInputs) !== null && _a !== void 0 ? _a : {};
            this.supportedCallTypes.teams = 0;
            this.supportedCallTypes.zoom = 0;
            // If the respective sources are defined, enable the telephony resources.
            for (const videoInput of Object.values(videoInputs)) {
                if (videoInput.code === '27') {
                    this.supportedCallTypes.teams = 1;
                }
                else if (videoInput.code === '15' || videoInput.code === '29') {
                    this.supportedCallTypes.zoom = 1;
                    this.zoomSourceCode = videoInput.code;
                }
            }
            this.state.calls.update(this.cynapCall, this.state.calls.addMissing({}));
            if (this.state.power.value) {
                yield this.updateCallsAndVideoMatrixRoutes([
                    'configuring',
                    'get.telephony',
                    'get.videoMatrixRoutes',
                ]);
            }
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return CommandSocketInitializer.initialize(this.socket, [
                {
                    errorCode: 'verifyFailed',
                    send: '\x08\xCB\x0C\x00',
                    next: /\x08\xCB\x0C\x01(\x00|\x01)/,
                },
            ], credentials);
        });
    }
    // other class methods
    byteLen(src, numBytes = 2) {
        const result = [];
        for (let i = numBytes - 1; i >= 0; i--) {
            result.push((src & (0x000000ff << (i << 3))) >> (i << 3));
        }
        return result;
    }
    // Convert numBytes bytes from a string to a big endian integer.
    // bytesToNum('\x01\x02', 0 ,2) = 258
    bytesToNum(bytes, byteOffset, numBytes) {
        let result = 0;
        for (let i = 0; i < numBytes; i++) {
            result += bytes.charCodeAt(byteOffset + i) << (8 * (numBytes - i - 1));
        }
        return result;
    }
    // Convert string to an array of numbers.
    encode(str) {
        const length = str.length;
        const data = new Array(length);
        for (let i = 0; i < length; i++) {
            data[i] = str.charCodeAt(i) & 0x0ff;
        }
        return data;
    }
    // End all windows, so the next action will appear full screen in window 0.
    endPresentation(tags) {
        return __awaiter(this, void 0, void 0, function* () {
            // Suspend polling so a query response doesn't quickly change the source.
            this.framework.suspendPolling(2000);
            const match = yield this.socket.send('\x09\xcb\x49\x03\x00\x00\x00', /([\x09\x89])\xcb\x49[\s\S]/, tags);
            return match[1] === '\x09';
        });
    }
    formatZoomMeetingId(meetingId, minLength = 6) {
        if (meetingId === undefined)
            return 'Meeting ID: Unknown';
        const idStr = meetingId.length > minLength
            ? [meetingId.substr(0, 3), meetingId.substr(3, 3), meetingId.substr(6)].join('-')
            : meetingId;
        return `Meeting ID: ${idStr}`;
    }
    // Parse the byte-fields returned from the 'Windows 3' command using the byte definitions in:
    // https://wolfvision.com/wolf/cynap_api_wolfprot/commands_156d_Public.html
    parseWindowInfo(windowsInfo) {
        const sources = [];
        let byteCount = 0;
        for (let window = 0; window < 4; window++) {
            let srcInfo = {};
            if (this.debug) {
                this.log.debug(`----------- Window ${window} -------------`);
                this.log.debug(`common block length[${window}]: ${windowsInfo.charCodeAt(byteCount)}`);
            }
            byteCount++;
            const source = windowsInfo.charCodeAt(byteCount);
            byteCount += 16; // get past common window and window specific length
            const windowBlockLength = this.bytesToNum(windowsInfo, byteCount, 2);
            byteCount += 2;
            if (this.debug) {
                this.log.debug(`window block length = ${windowBlockLength}`);
            }
            switch (source) {
                case 0:
                    // home screen
                    srcInfo = { source, window, name: 'Home' };
                    break;
                case 1: // visualizer
                case 2: // HDMI
                    const index = this.bytesToNum(windowsInfo, byteCount, 4);
                    byteCount += 4;
                    let inputNameLength = this.bytesToNum(windowsInfo, byteCount, 2);
                    byteCount += 2;
                    let inputName = windowsInfo.slice(byteCount, byteCount + inputNameLength);
                    byteCount += inputNameLength;
                    // Use source 80 for HDMI 2 (consistent with equipmentTypes entry).
                    srcInfo = { source: index === 0 ? source : 80, window, name: inputName };
                    break;
                case 3:
                case 15:
                case 19:
                case 20:
                case 21:
                case 22:
                case 23:
                case 26:
                case 27: // Teams
                case 29: // Zoom from cynap UI
                    // browser, teams, zoom
                    const urlLength = this.bytesToNum(windowsInfo, byteCount, 2);
                    byteCount += 2;
                    const url = windowsInfo.slice(byteCount, byteCount + urlLength);
                    byteCount += urlLength;
                    if (this.debug) {
                        this.log.debug(`url: ${url}`);
                    }
                    const titleLength = this.bytesToNum(windowsInfo, byteCount, 2);
                    byteCount += 2;
                    byteCount += titleLength;
                    // skip ahead
                    byteCount += windowBlockLength - (2 + urlLength + 2 + titleLength);
                    srcInfo = {
                        source,
                        window,
                        url,
                        name: source === 29 || source === 15 ? 'zoom' : 'microsoft/browser',
                    };
                    break;
                case 4:
                case 5:
                case 7:
                case 24:
                case 28:
                    inputNameLength = this.bytesToNum(windowsInfo, byteCount, 2);
                    byteCount += 2;
                    inputName = windowsInfo.slice(byteCount, byteCount + inputNameLength);
                    srcInfo = { source, window, name: 'miracast/airplay' };
                    break;
                case 6:
                case 14:
                    // audio/video
                    byteCount += 4 + 4 + 1 + 1;
                    srcInfo = { source, window, name: 'audio/video' };
                    break;
                case 8: // image
                    byteCount += 4 + 4; // skip past image number, total number images
                    const filenameLength = this.bytesToNum(windowsInfo, byteCount, 2);
                    byteCount += 2;
                    byteCount += filenameLength;
                    srcInfo = { source, window, name: 'image' };
                    break;
                case 9: // pdf
                    byteCount += 4 + 4 + 4; // skip past page, total num pages, zoom level
                    srcInfo = { source, window, name: 'pdf' };
                    break;
                case 10: // office document
                case 11:
                case 12:
                    byteCount += 4 + 4; // skip past page, total pages
                    const docNameLength = this.bytesToNum(windowsInfo, byteCount, 2);
                    byteCount += 2;
                    byteCount += docNameLength;
                    byteCount += 4; // skip past worksheet pages
                    const worksheetNameLength = this.bytesToNum(windowsInfo, byteCount, 2);
                    byteCount += 2;
                    byteCount += worksheetNameLength;
                    srcInfo = { source, window, name: 'office document' };
                    break;
                case 13: // whiteboard
                    byteCount += windowBlockLength; // skip to end
                    srcInfo = { source, window, name: 'whiteboard' };
                    break;
                case 16: // webcam
                case 17: // stream
                    const nameLength = this.bytesToNum(windowsInfo, byteCount, 2);
                    byteCount += 2;
                    byteCount += nameLength;
                    srcInfo = { source, window, name: source === 16 ? 'webcam' : 'stream' };
                    break;
                case 30: // office 365 whiteboard
                    byteCount += windowBlockLength; // skip to end
                    srcInfo = { source, window, name: 'office whiteboard' };
                    break;
                case 31: // office planner
                    byteCount += windowBlockLength; // skip to end
                    srcInfo = { source, window, name: 'office planner' };
                    break;
                default:
                    this.log.error(`Unknown WolfVision source selected`);
                    break;
            }
            if (this.debug) {
                this.log.debug(`srcInfo = ${JSON.stringify(srcInfo)}`);
            }
            sources.push(srcInfo);
        }
        if (this.debug)
            this.log.debug(`-------------------------------`);
        return sources;
    }
    updateCallsAndVideoMatrixRoutes(tags) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            // Send the "windows 3" command, parse the response, and update this.state.videoMatrixRoutes
            // and this.state.calls.
            const match = yield this.socket.send(`\x08\xcd\x42\x00`, // 'windows 3' command from Cynap API
            /^\x0c\xcd\x42([\s\S]{6})([\s\S]+)|^\x88\xcd\x42[\s\S]/, 
            // match[1]: 16 bytes correpond to: window type, fs, x0, x1, y0, y1, w0, w1, h0, h1, mu, volume, aux, rec, webrtc, restricted
            // match[2]: lb0..lb1: window type specific block length
            // match[3]: window specific block information
            tags);
            if (match[2]) {
                const windows = this.parseWindowInfo(match[2]);
                const teamOrZoomWindow = windows.find(win => { var _a; return [15, 27, 29].includes((_a = win === null || win === void 0 ? void 0 : win.source) !== null && _a !== void 0 ? _a : 0); });
                let cynapVideoInput = '0';
                if (!teamOrZoomWindow) {
                    // Show the selected source as the source in window 0.
                    cynapVideoInput = ((_b = (_a = windows[0]) === null || _a === void 0 ? void 0 : _a.source) !== null && _b !== void 0 ? _b : 0).toString();
                    // If there are no active calls on the screen, end any active call.
                    if (this.state.calls.values[this.cynapCall] &&
                        this.state.calls.values[this.cynapCall].callState !== 'disconnected') {
                        if (this.framework.phase === 'controlling')
                            this.framework.suspendPolling(3000);
                        this.state.calls.disconnect(this.cynapCall);
                    }
                }
                else {
                    // Zoom or Teams calls
                    const url = (_c = teamOrZoomWindow === null || teamOrZoomWindow === void 0 ? void 0 : teamOrZoomWindow.url) !== null && _c !== void 0 ? _c : '';
                    let callType = 'teams';
                    let dialString = '';
                    if (url.includes('zoom.us')) {
                        const urlRegExp = /zoom.us\/..\/(?:join\/)?(\d+)/i;
                        const meetingIdMatch = urlRegExp.exec(url);
                        callType = 'zoom';
                        dialString = meetingIdMatch ? meetingIdMatch[1] : undefined;
                        cynapVideoInput = this.zoomSourceCode;
                        if (this.debug) {
                            this.log.debug(`detected zoom meeting - dialString = ${dialString}`);
                        }
                    }
                    else if (url.includes('teams.microsoft.com')) {
                        callType = 'teams';
                        cynapVideoInput = '27';
                    }
                    else {
                        if (this.debug)
                            this.log.debug(`detecting team or zooms input but no URL`);
                    }
                    if (url.match(/zoom\.us\/wc\/join\/\w+/i) ||
                        url.match(/zoom\.us\/wc\/.+\/join\?track_id/i) ||
                        url.match(/teams\.microsoft\.com\/_#\/pre-join-calling/i) ||
                        url.match(/teams\.microsoft.com\/_#\/modern-calling/i)) {
                        // For Zoom, there doesn't seem to be a way to know that a call has ended, so
                        // we use the end presentation as a trigger to hangup the call.
                        const callState = (_d = this.state.calls.values[this.cynapCall]) === null || _d === void 0 ? void 0 : _d.callState;
                        // If Mira Connect placed the call, we already populated the caller ID info, so
                        // extras can be empty. For a call placed on the Cynap, we fill in some default
                        // values for the caller ID.
                        const extras = callState === 'connected' || callState === 'ringing'
                            ? {}
                            : callType === 'teams'
                                ? {
                                    dialString: 'https://teams.microsoft.com/l/meetup',
                                    displayDialString: 'Microsoft Teams Meeting',
                                }
                                : {
                                    dialString,
                                    displayDialString: this.formatZoomMeetingId(dialString),
                                };
                        this.state.calls.connect(this.cynapCall, extras, undefined, callType);
                    }
                    else if (this.cynapCall in this.state.calls.values &&
                        (url.match(/teams\.microsoft\.com\/_#\/post-calling/) ||
                            url.match(/teams\.microsoft.com\/_#\/calendarv/) ||
                            url.match(/teams.microsoft.com\/_#\/conversations/))) {
                        this.state.calls.disconnect(this.cynapCall);
                    }
                    else {
                        // Other URLs seen in testing:
                        // url === '' // empty URL happens if you click the dial button twice quickly
                        // url.match(/teams\.microsoft\.com\/_#\/.+/i)
                        // url.match(/teams\.microsoft\.com\/.+\/launcher\/launcher\.html/i)
                        // url.match(/teams\.microsoft\.com\/_?#\/.+\/meetup-join/i)
                        // url.match(/teams\.microsoft\.com\/_#id_token=.+/i)
                        // url.match(/teams\.microsoft\.com\/go#/i)
                        // url.match(/login\.microsoftonline\.com\/common\/oauth2/i)
                        // url.match(/teams\.microsoft\.com\/_?$/i)
                        // url.match(/zoom\.us\/wc\/join\//i)
                        // url.match(/chrome:\/\/newtab\//i) // if you try to select the zoom source
                        // also any an error as any URL browsed will be reported
                    }
                }
                this.state.videoMatrixRoutes.update(this.cynapVideoOutput, cynapVideoInput);
            }
        });
    }
}
// static properties
WolfVisionCynap.driverType = 'socketDriver';
WolfVisionCynap.key = '-NBlvFUC6ts4r-VGpDuo';
WolfVisionCynap.socketOptions = [
    {
        commandExtractor: (buffer) => {
            const validCodes = [0xca, 0xcb, 0xcc, 0xcd];
            for (let i = 0; i <= buffer.length - 4; i++) {
                if ((buffer.charCodeAt(i) === 0x08 || buffer.charCodeAt(i) === 0x09) &&
                    validCodes.includes(buffer.charCodeAt(i + 1))) {
                    // single byte cmd header and command is next two bytes
                    const length = buffer.charCodeAt(i + 3);
                    if (length <= buffer.length - 4) {
                        const command = buffer.slice(i, i + 4 + length);
                        buffer = buffer.slice(i + 4 + length);
                        return { command, buffer };
                    }
                }
                else if ((buffer.charCodeAt(i) == 0x88 || buffer.charCodeAt(i) === 0x89) &&
                    validCodes.includes(buffer.charCodeAt(i + 1))) {
                    // error response
                    const command = buffer.slice(i, i + 4);
                    buffer = buffer.slice(i + 4);
                    return { command, buffer };
                }
                else if (buffer.charCodeAt(i) === 0x0c &&
                    validCodes.includes(buffer.charCodeAt(i + 1))) {
                    // long command response
                    const length = (buffer.charCodeAt(i + 3) << 8) + buffer.charCodeAt(i + 4);
                    if (length <= buffer.length - 4) {
                        const command = buffer.slice(i, i + 5 + length);
                        buffer = buffer.slice(i + 5 + length);
                        return { command, buffer };
                    }
                }
                else if (
                // 0b 01 cd 28 ...
                buffer.charCodeAt(i) === 0x0b &&
                    buffer.charCodeAt(i + 1) === 1 &&
                    validCodes.includes(buffer.charCodeAt(i + 2))) {
                    // long command
                    const length = (buffer.charCodeAt(i + 4) << 24) +
                        (buffer.charCodeAt(i + 5) << 16) +
                        (buffer.charCodeAt(i + 6) << 8) +
                        buffer.charCodeAt(i + 7);
                    if (length <= buffer.length - 8) {
                        const command = buffer.slice(i, i + 8 + length);
                        buffer = buffer.slice(i + 8 + length);
                        return { command, buffer };
                    }
                }
            }
            return undefined;
        },
        isBinary: true,
        port: 50915,
        sendTerminator: '',
    },
];
